module.exports = __webpack_public_path__ + "static/img/190725-breast-feeding.c453cf5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gensunicerse/190725-breast-feeding.jpg
// module id = nf7E
// module chunks = 0